module.exports = __webpack_public_path__ + "img/QR-Scanning.ae180ebb.png";